export interface ScheduleEntry {
  day: string;
  time: string;
}

export interface TeamMember {
  name: string;
  role: string;
  image: string;
}

export interface ContactEntry {
  type: string;
  value: string;
}

export interface ChurchFormData {
  name: string;
  diocese: string;
  city: string;
  address: string;
  description: string;
  image: string;
  imageFile: File | null;
  video: string;
  videoFile: File | null;
  massSchedule: ScheduleEntry[];
  confessionSchedule: ScheduleEntry[];
  officeHours: ScheduleEntry[];
  team: TeamMember[];
  contacts: ContactEntry[];
}

export const emptyFormData = (): ChurchFormData => ({
  name: "",
  diocese: "",
  city: "",
  address: "",
  description: "",
  image: "",
  imageFile: null,
  video: "",
  videoFile: null,
  massSchedule: [{ day: "", time: "" }],
  confessionSchedule: [{ day: "", time: "" }],
  officeHours: [{ day: "", time: "" }],
  team: [{ name: "", role: "Curé", image: "" }],
  contacts: [{ type: "Téléphone", value: "" }],
});
